import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {GetLogsResponse} from '../models/logging/getLogs.response';
import {GetLogsRequest} from '../models/logging/getLogs.request';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  private LOGGING_URL: string = environment.BASE_URL + 'logs';

  constructor(private http: HttpClient) {
  }

  getLogs(request: GetLogsRequest): Observable<GetLogsResponse> {
    return this.http.post<GetLogsResponse>(`${this.LOGGING_URL}`, request).pipe(map(res => {
      res.logs = res.logs.map(log => {
        log.timestamp = new Date(log.timestamp);
        if (log.body) {
          log.bodyJson = JSON.parse(log.body);
        }
        return log;
      });
      return res;
    }));
  }
}
